// AUTO-GENERATED by scripts/generate-catalog.mjs — DO NOT EDIT.
// Deep-sky objects: the complete Messier catalog (110) plus notable extra objects. Constellation assignment computed with the astronomy engine.
// Data sources: Messier catalog public data; coordinates J2000
// See src/catalog/data/attribution.ts for licenses and provenance.


export type DeepSkyType = "galaxy" | "nebula" | "planetary" | "cluster" | "star";

export interface DeepSkyObject {
  id: string;
  name: string;
  type: DeepSkyType;
  ra: number;
  dec: number;
  mag: number;
  sizeArcmin: number;
  con: string;
}

export const DEEP_SKY: readonly DeepSkyObject[] = [
  {
    "id": "M1",
    "name": "Crab Nebula",
    "type": "nebula",
    "ra": 83.6331,
    "dec": 22.0145,
    "mag": 8.4,
    "sizeArcmin": 6,
    "con": "Tau"
  },
  {
    "id": "M2",
    "name": "M2",
    "type": "cluster",
    "ra": 323.3625,
    "dec": -0.8233,
    "mag": 6.5,
    "sizeArcmin": 12.9,
    "con": "Aqr"
  },
  {
    "id": "M3",
    "name": "M3",
    "type": "cluster",
    "ra": 205.5483,
    "dec": 28.3772,
    "mag": 6.2,
    "sizeArcmin": 16.2,
    "con": "CVn"
  },
  {
    "id": "M4",
    "name": "M4",
    "type": "cluster",
    "ra": 245.8975,
    "dec": -26.5258,
    "mag": 5.6,
    "sizeArcmin": 26.3,
    "con": "Sco"
  },
  {
    "id": "M5",
    "name": "M5",
    "type": "cluster",
    "ra": 229.6383,
    "dec": 2.0811,
    "mag": 5.6,
    "sizeArcmin": 17.4,
    "con": "Ser"
  },
  {
    "id": "M6",
    "name": "Butterfly Cluster",
    "type": "cluster",
    "ra": 265.0833,
    "dec": -32.2533,
    "mag": 4.2,
    "sizeArcmin": 20,
    "con": "Sco"
  },
  {
    "id": "M7",
    "name": "Ptolemy Cluster",
    "type": "cluster",
    "ra": 268.4625,
    "dec": -34.7933,
    "mag": 3.3,
    "sizeArcmin": 80,
    "con": "Sco"
  },
  {
    "id": "M8",
    "name": "Lagoon Nebula",
    "type": "nebula",
    "ra": 270.9042,
    "dec": -24.3867,
    "mag": 6,
    "sizeArcmin": 90,
    "con": "Sgr"
  },
  {
    "id": "M9",
    "name": "M9",
    "type": "cluster",
    "ra": 259.7917,
    "dec": -18.52,
    "mag": 7.7,
    "sizeArcmin": 9.3,
    "con": "Oph"
  },
  {
    "id": "M10",
    "name": "M10",
    "type": "cluster",
    "ra": 254.2833,
    "dec": -4.0994,
    "mag": 6.6,
    "sizeArcmin": 15.1,
    "con": "Oph"
  },
  {
    "id": "M11",
    "name": "Wild Duck Cluster",
    "type": "cluster",
    "ra": 282.7708,
    "dec": -6.27,
    "mag": 6.3,
    "sizeArcmin": 13,
    "con": "Sct"
  },
  {
    "id": "M12",
    "name": "M12",
    "type": "cluster",
    "ra": 251.8083,
    "dec": -1.9478,
    "mag": 6.7,
    "sizeArcmin": 14.5,
    "con": "Oph"
  },
  {
    "id": "M13",
    "name": "Hercules Cluster",
    "type": "cluster",
    "ra": 250.4236,
    "dec": 36.4606,
    "mag": 5.8,
    "sizeArcmin": 16.6,
    "con": "Her"
  },
  {
    "id": "M14",
    "name": "M14",
    "type": "cluster",
    "ra": 264.4,
    "dec": -3.2461,
    "mag": 7.6,
    "sizeArcmin": 11.7,
    "con": "Oph"
  },
  {
    "id": "M15",
    "name": "M15",
    "type": "cluster",
    "ra": 322.4931,
    "dec": 12.1669,
    "mag": 6.2,
    "sizeArcmin": 12.3,
    "con": "Peg"
  },
  {
    "id": "M16",
    "name": "Eagle Nebula",
    "type": "nebula",
    "ra": 274.7,
    "dec": -13.7833,
    "mag": 6,
    "sizeArcmin": 7,
    "con": "Ser"
  },
  {
    "id": "M17",
    "name": "Omega Nebula",
    "type": "nebula",
    "ra": 275.1083,
    "dec": -16.1767,
    "mag": 6,
    "sizeArcmin": 11,
    "con": "Sgr"
  },
  {
    "id": "M18",
    "name": "M18",
    "type": "cluster",
    "ra": 274.9917,
    "dec": -17.1017,
    "mag": 7.5,
    "sizeArcmin": 9,
    "con": "Sgr"
  },
  {
    "id": "M19",
    "name": "M19",
    "type": "cluster",
    "ra": 255.6583,
    "dec": -26.2681,
    "mag": 6.8,
    "sizeArcmin": 13.5,
    "con": "Oph"
  },
  {
    "id": "M20",
    "name": "Trifid Nebula",
    "type": "nebula",
    "ra": 270.675,
    "dec": -23.03,
    "mag": 6.3,
    "sizeArcmin": 28,
    "con": "Sgr"
  },
  {
    "id": "M21",
    "name": "M21",
    "type": "cluster",
    "ra": 271.0542,
    "dec": -22.49,
    "mag": 6.5,
    "sizeArcmin": 13,
    "con": "Sgr"
  },
  {
    "id": "M22",
    "name": "Sagittarius Cluster",
    "type": "cluster",
    "ra": 279.1,
    "dec": -23.9033,
    "mag": 5.1,
    "sizeArcmin": 24,
    "con": "Sgr"
  },
  {
    "id": "M23",
    "name": "M23",
    "type": "cluster",
    "ra": 269.2333,
    "dec": -19.0117,
    "mag": 6.9,
    "sizeArcmin": 27,
    "con": "Sgr"
  },
  {
    "id": "M24",
    "name": "Sagittarius Star Cloud",
    "type": "cluster",
    "ra": 274.625,
    "dec": -18.4167,
    "mag": 4.6,
    "sizeArcmin": 120,
    "con": "Sgr"
  },
  {
    "id": "M25",
    "name": "M25",
    "type": "cluster",
    "ra": 277.9458,
    "dec": -19.2567,
    "mag": 4.6,
    "sizeArcmin": 40,
    "con": "Sgr"
  },
  {
    "id": "M26",
    "name": "M26",
    "type": "cluster",
    "ra": 281.325,
    "dec": -9.385,
    "mag": 8,
    "sizeArcmin": 15,
    "con": "Sct"
  },
  {
    "id": "M27",
    "name": "Dumbbell Nebula",
    "type": "planetary",
    "ra": 299.9,
    "dec": 22.7211,
    "mag": 7.4,
    "sizeArcmin": 8,
    "con": "Vul"
  },
  {
    "id": "M28",
    "name": "M28",
    "type": "cluster",
    "ra": 276.1333,
    "dec": -24.87,
    "mag": 6.8,
    "sizeArcmin": 11.2,
    "con": "Sgr"
  },
  {
    "id": "M29",
    "name": "M29",
    "type": "cluster",
    "ra": 305.9833,
    "dec": 38.525,
    "mag": 7.1,
    "sizeArcmin": 7,
    "con": "Cyg"
  },
  {
    "id": "M30",
    "name": "M30",
    "type": "cluster",
    "ra": 325.0917,
    "dec": -23.18,
    "mag": 7.2,
    "sizeArcmin": 12,
    "con": "Cap"
  },
  {
    "id": "M31",
    "name": "Andromeda Galaxy",
    "type": "galaxy",
    "ra": 10.6847,
    "dec": 41.2686,
    "mag": 3.4,
    "sizeArcmin": 190,
    "con": "And"
  },
  {
    "id": "M32",
    "name": "M32",
    "type": "galaxy",
    "ra": 10.675,
    "dec": 40.865,
    "mag": 8.1,
    "sizeArcmin": 7,
    "con": "And"
  },
  {
    "id": "M33",
    "name": "Triangulum Galaxy",
    "type": "galaxy",
    "ra": 23.4625,
    "dec": 30.6603,
    "mag": 5.7,
    "sizeArcmin": 73,
    "con": "Tri"
  },
  {
    "id": "M34",
    "name": "M34",
    "type": "cluster",
    "ra": 40.5208,
    "dec": 42.7617,
    "mag": 5.5,
    "sizeArcmin": 35,
    "con": "Per"
  },
  {
    "id": "M35",
    "name": "M35",
    "type": "cluster",
    "ra": 92.225,
    "dec": 24.3333,
    "mag": 5.1,
    "sizeArcmin": 28,
    "con": "Gem"
  },
  {
    "id": "M36",
    "name": "M36",
    "type": "cluster",
    "ra": 84.05,
    "dec": 34.14,
    "mag": 6.3,
    "sizeArcmin": 12,
    "con": "Aur"
  },
  {
    "id": "M37",
    "name": "M37",
    "type": "cluster",
    "ra": 88.075,
    "dec": 32.55,
    "mag": 6.2,
    "sizeArcmin": 24,
    "con": "Aur"
  },
  {
    "id": "M38",
    "name": "M38",
    "type": "cluster",
    "ra": 82.175,
    "dec": 35.8383,
    "mag": 7.4,
    "sizeArcmin": 21,
    "con": "Aur"
  },
  {
    "id": "M39",
    "name": "M39",
    "type": "cluster",
    "ra": 323.05,
    "dec": 48.44,
    "mag": 4.6,
    "sizeArcmin": 32,
    "con": "Cyg"
  },
  {
    "id": "M40",
    "name": "Winnecke 4",
    "type": "star",
    "ra": 185.55,
    "dec": 58.0833,
    "mag": 9,
    "sizeArcmin": 1,
    "con": "UMa"
  },
  {
    "id": "M41",
    "name": "M41",
    "type": "cluster",
    "ra": 101.5042,
    "dec": -20.7567,
    "mag": 4.5,
    "sizeArcmin": 38,
    "con": "CMa"
  },
  {
    "id": "M42",
    "name": "Orion Nebula",
    "type": "nebula",
    "ra": 83.8208,
    "dec": -5.3911,
    "mag": 4,
    "sizeArcmin": 85,
    "con": "Ori"
  },
  {
    "id": "M43",
    "name": "De Mairan's Nebula",
    "type": "nebula",
    "ra": 83.8792,
    "dec": -5.27,
    "mag": 9,
    "sizeArcmin": 20,
    "con": "Ori"
  },
  {
    "id": "M44",
    "name": "Beehive Cluster",
    "type": "cluster",
    "ra": 130.1,
    "dec": 19.6667,
    "mag": 3.7,
    "sizeArcmin": 95,
    "con": "Cnc"
  },
  {
    "id": "M45",
    "name": "Pleiades",
    "type": "cluster",
    "ra": 56.75,
    "dec": 24.1167,
    "mag": 1.6,
    "sizeArcmin": 110,
    "con": "Tau"
  },
  {
    "id": "M46",
    "name": "M46",
    "type": "cluster",
    "ra": 115.4458,
    "dec": -14.81,
    "mag": 6.1,
    "sizeArcmin": 27,
    "con": "Pup"
  },
  {
    "id": "M47",
    "name": "M47",
    "type": "cluster",
    "ra": 114.1458,
    "dec": -14.4833,
    "mag": 4.4,
    "sizeArcmin": 30,
    "con": "Pup"
  },
  {
    "id": "M48",
    "name": "M48",
    "type": "cluster",
    "ra": 123.4292,
    "dec": -5.7333,
    "mag": 5.5,
    "sizeArcmin": 54,
    "con": "Hya"
  },
  {
    "id": "M49",
    "name": "M49",
    "type": "galaxy",
    "ra": 187.4458,
    "dec": 8,
    "mag": 8.4,
    "sizeArcmin": 9,
    "con": "Vir"
  },
  {
    "id": "M50",
    "name": "M50",
    "type": "cluster",
    "ra": 105.7,
    "dec": -8.3433,
    "mag": 5.9,
    "sizeArcmin": 15,
    "con": "Mon"
  },
  {
    "id": "M51",
    "name": "Whirlpool Galaxy",
    "type": "galaxy",
    "ra": 202.4675,
    "dec": 47.1953,
    "mag": 8.4,
    "sizeArcmin": 11,
    "con": "CVn"
  },
  {
    "id": "M52",
    "name": "M52",
    "type": "cluster",
    "ra": 351.05,
    "dec": 61.5833,
    "mag": 7.3,
    "sizeArcmin": 13,
    "con": "Cas"
  },
  {
    "id": "M53",
    "name": "M53",
    "type": "cluster",
    "ra": 198.2292,
    "dec": 18.1692,
    "mag": 7.6,
    "sizeArcmin": 12.6,
    "con": "Com"
  },
  {
    "id": "M54",
    "name": "M54",
    "type": "cluster",
    "ra": 283.7625,
    "dec": -30.48,
    "mag": 7.6,
    "sizeArcmin": 9.1,
    "con": "Sgr"
  },
  {
    "id": "M55",
    "name": "M55",
    "type": "cluster",
    "ra": 294.9958,
    "dec": -30.9617,
    "mag": 6.3,
    "sizeArcmin": 19,
    "con": "Sgr"
  },
  {
    "id": "M56",
    "name": "M56",
    "type": "cluster",
    "ra": 289.15,
    "dec": 30.1833,
    "mag": 8.3,
    "sizeArcmin": 7,
    "con": "Lyr"
  },
  {
    "id": "M57",
    "name": "Ring Nebula",
    "type": "planetary",
    "ra": 283.3958,
    "dec": 33.0292,
    "mag": 8.8,
    "sizeArcmin": 1.4,
    "con": "Lyr"
  },
  {
    "id": "M58",
    "name": "M58",
    "type": "galaxy",
    "ra": 189.4333,
    "dec": 11.8181,
    "mag": 9.7,
    "sizeArcmin": 6,
    "con": "Vir"
  },
  {
    "id": "M59",
    "name": "M59",
    "type": "galaxy",
    "ra": 190.5083,
    "dec": 11.6469,
    "mag": 9.6,
    "sizeArcmin": 5,
    "con": "Vir"
  },
  {
    "id": "M60",
    "name": "M60",
    "type": "galaxy",
    "ra": 190.9167,
    "dec": 11.5525,
    "mag": 8.8,
    "sizeArcmin": 7,
    "con": "Vir"
  },
  {
    "id": "M61",
    "name": "M61",
    "type": "galaxy",
    "ra": 185.4792,
    "dec": 4.4736,
    "mag": 9.7,
    "sizeArcmin": 6,
    "con": "Vir"
  },
  {
    "id": "M62",
    "name": "M62",
    "type": "cluster",
    "ra": 255.3042,
    "dec": -30.1136,
    "mag": 6.5,
    "sizeArcmin": 14,
    "con": "Oph"
  },
  {
    "id": "M63",
    "name": "Sunflower Galaxy",
    "type": "galaxy",
    "ra": 198.9542,
    "dec": 42.0292,
    "mag": 8.6,
    "sizeArcmin": 10,
    "con": "CVn"
  },
  {
    "id": "M64",
    "name": "Black Eye Galaxy",
    "type": "galaxy",
    "ra": 194.1833,
    "dec": 21.6828,
    "mag": 8.5,
    "sizeArcmin": 9,
    "con": "Com"
  },
  {
    "id": "M65",
    "name": "M65",
    "type": "galaxy",
    "ra": 169.7333,
    "dec": 13.0922,
    "mag": 9.3,
    "sizeArcmin": 8,
    "con": "Leo"
  },
  {
    "id": "M66",
    "name": "M66",
    "type": "galaxy",
    "ra": 170.0625,
    "dec": 12.9917,
    "mag": 8.9,
    "sizeArcmin": 8,
    "con": "Leo"
  },
  {
    "id": "M67",
    "name": "M67",
    "type": "cluster",
    "ra": 132.825,
    "dec": 11.8,
    "mag": 6.1,
    "sizeArcmin": 30,
    "con": "Cnc"
  },
  {
    "id": "M68",
    "name": "M68",
    "type": "cluster",
    "ra": 189.8667,
    "dec": -26.7431,
    "mag": 7.8,
    "sizeArcmin": 11,
    "con": "Hya"
  },
  {
    "id": "M69",
    "name": "M69",
    "type": "cluster",
    "ra": 277.8458,
    "dec": -32.3478,
    "mag": 7.6,
    "sizeArcmin": 7.1,
    "con": "Sgr"
  },
  {
    "id": "M70",
    "name": "M70",
    "type": "cluster",
    "ra": 280.8042,
    "dec": -32.2919,
    "mag": 7.9,
    "sizeArcmin": 7.8,
    "con": "Sgr"
  },
  {
    "id": "M71",
    "name": "M71",
    "type": "cluster",
    "ra": 298.4417,
    "dec": 18.7789,
    "mag": 8.2,
    "sizeArcmin": 7.2,
    "con": "Sge"
  },
  {
    "id": "M72",
    "name": "M72",
    "type": "cluster",
    "ra": 313.3667,
    "dec": -12.5369,
    "mag": 9.3,
    "sizeArcmin": 5.9,
    "con": "Aqr"
  },
  {
    "id": "M73",
    "name": "M73",
    "type": "cluster",
    "ra": 314.725,
    "dec": -12.6333,
    "mag": 8.9,
    "sizeArcmin": 2.8,
    "con": "Aqr"
  },
  {
    "id": "M74",
    "name": "M74",
    "type": "galaxy",
    "ra": 24.175,
    "dec": 15.7833,
    "mag": 9.4,
    "sizeArcmin": 10,
    "con": "Psc"
  },
  {
    "id": "M75",
    "name": "M75",
    "type": "cluster",
    "ra": 301.5208,
    "dec": -21.9214,
    "mag": 8.5,
    "sizeArcmin": 5.6,
    "con": "Sgr"
  },
  {
    "id": "M76",
    "name": "Little Dumbbell Nebula",
    "type": "planetary",
    "ra": 25.5833,
    "dec": 51.5753,
    "mag": 10.1,
    "sizeArcmin": 2.7,
    "con": "Per"
  },
  {
    "id": "M77",
    "name": "Cetus A",
    "type": "galaxy",
    "ra": 40.6708,
    "dec": -0.0133,
    "mag": 8.9,
    "sizeArcmin": 7,
    "con": "Cet"
  },
  {
    "id": "M78",
    "name": "M78",
    "type": "nebula",
    "ra": 86.6958,
    "dec": 0.07,
    "mag": 8.3,
    "sizeArcmin": 8,
    "con": "Ori"
  },
  {
    "id": "M79",
    "name": "M79",
    "type": "cluster",
    "ra": 81.0458,
    "dec": -24.5242,
    "mag": 7.7,
    "sizeArcmin": 7.6,
    "con": "Lep"
  },
  {
    "id": "M80",
    "name": "M80",
    "type": "cluster",
    "ra": 244.2625,
    "dec": -22.975,
    "mag": 7.3,
    "sizeArcmin": 7,
    "con": "Sco"
  },
  {
    "id": "M81",
    "name": "Bode's Galaxy",
    "type": "galaxy",
    "ra": 148.8875,
    "dec": 69.0653,
    "mag": 6.9,
    "sizeArcmin": 21,
    "con": "UMa"
  },
  {
    "id": "M82",
    "name": "Cigar Galaxy",
    "type": "galaxy",
    "ra": 148.9667,
    "dec": 69.6797,
    "mag": 8.4,
    "sizeArcmin": 11,
    "con": "UMa"
  },
  {
    "id": "M83",
    "name": "Southern Pinwheel Galaxy",
    "type": "galaxy",
    "ra": 204.2542,
    "dec": -29.8656,
    "mag": 7.5,
    "sizeArcmin": 13,
    "con": "Hya"
  },
  {
    "id": "M84",
    "name": "M84",
    "type": "galaxy",
    "ra": 186.2667,
    "dec": 12.8869,
    "mag": 9.1,
    "sizeArcmin": 5,
    "con": "Vir"
  },
  {
    "id": "M85",
    "name": "M85",
    "type": "galaxy",
    "ra": 186.35,
    "dec": 18.1911,
    "mag": 9.1,
    "sizeArcmin": 7,
    "con": "Com"
  },
  {
    "id": "M86",
    "name": "M86",
    "type": "galaxy",
    "ra": 186.55,
    "dec": 12.9461,
    "mag": 8.9,
    "sizeArcmin": 7,
    "con": "Vir"
  },
  {
    "id": "M87",
    "name": "Virgo A",
    "type": "galaxy",
    "ra": 187.7042,
    "dec": 12.3911,
    "mag": 8.6,
    "sizeArcmin": 7,
    "con": "Vir"
  },
  {
    "id": "M88",
    "name": "M88",
    "type": "galaxy",
    "ra": 187.9958,
    "dec": 14.4206,
    "mag": 9.6,
    "sizeArcmin": 7,
    "con": "Com"
  },
  {
    "id": "M89",
    "name": "M89",
    "type": "galaxy",
    "ra": 188.9167,
    "dec": 12.5536,
    "mag": 9.8,
    "sizeArcmin": 5,
    "con": "Vir"
  },
  {
    "id": "M90",
    "name": "M90",
    "type": "galaxy",
    "ra": 189.2083,
    "dec": 13.1636,
    "mag": 9.5,
    "sizeArcmin": 9,
    "con": "Vir"
  },
  {
    "id": "M91",
    "name": "M91",
    "type": "galaxy",
    "ra": 188.8583,
    "dec": 14.4964,
    "mag": 10.2,
    "sizeArcmin": 5,
    "con": "Com"
  },
  {
    "id": "M92",
    "name": "M92",
    "type": "cluster",
    "ra": 259.2792,
    "dec": 43.1364,
    "mag": 6.3,
    "sizeArcmin": 11.2,
    "con": "Her"
  },
  {
    "id": "M93",
    "name": "M93",
    "type": "cluster",
    "ra": 116.125,
    "dec": -23.8567,
    "mag": 6.2,
    "sizeArcmin": 22,
    "con": "Pup"
  },
  {
    "id": "M94",
    "name": "Cat's Eye Galaxy",
    "type": "galaxy",
    "ra": 192.7208,
    "dec": 41.1206,
    "mag": 8.2,
    "sizeArcmin": 11,
    "con": "CVn"
  },
  {
    "id": "M95",
    "name": "M95",
    "type": "galaxy",
    "ra": 160.9917,
    "dec": 11.7039,
    "mag": 9.7,
    "sizeArcmin": 7,
    "con": "Leo"
  },
  {
    "id": "M96",
    "name": "M96",
    "type": "galaxy",
    "ra": 161.6917,
    "dec": 11.82,
    "mag": 9.2,
    "sizeArcmin": 6,
    "con": "Leo"
  },
  {
    "id": "M97",
    "name": "Owl Nebula",
    "type": "planetary",
    "ra": 168.7,
    "dec": 55.0167,
    "mag": 9.9,
    "sizeArcmin": 3.4,
    "con": "UMa"
  },
  {
    "id": "M98",
    "name": "M98",
    "type": "galaxy",
    "ra": 183.3125,
    "dec": 14.9003,
    "mag": 10.1,
    "sizeArcmin": 9,
    "con": "Com"
  },
  {
    "id": "M99",
    "name": "Pinwheel Galaxy",
    "type": "galaxy",
    "ra": 184.7083,
    "dec": 14.4167,
    "mag": 9.9,
    "sizeArcmin": 5,
    "con": "Com"
  },
  {
    "id": "M100",
    "name": "M100",
    "type": "galaxy",
    "ra": 185.7292,
    "dec": 15.8225,
    "mag": 9.3,
    "sizeArcmin": 7,
    "con": "Com"
  },
  {
    "id": "M101",
    "name": "Pinwheel Galaxy",
    "type": "galaxy",
    "ra": 210.8042,
    "dec": 54.3489,
    "mag": 7.9,
    "sizeArcmin": 29,
    "con": "UMa"
  },
  {
    "id": "M102",
    "name": "Spindle Galaxy",
    "type": "galaxy",
    "ra": 226.625,
    "dec": 55.7631,
    "mag": 9.9,
    "sizeArcmin": 5,
    "con": "Dra"
  },
  {
    "id": "M103",
    "name": "M103",
    "type": "cluster",
    "ra": 23.3,
    "dec": 60.7,
    "mag": 7.4,
    "sizeArcmin": 6,
    "con": "Cas"
  },
  {
    "id": "M104",
    "name": "Sombrero Galaxy",
    "type": "galaxy",
    "ra": 189.9958,
    "dec": -11.6231,
    "mag": 8,
    "sizeArcmin": 9,
    "con": "Vir"
  },
  {
    "id": "M105",
    "name": "M105",
    "type": "galaxy",
    "ra": 161.9583,
    "dec": 12.5817,
    "mag": 9.3,
    "sizeArcmin": 5,
    "con": "Leo"
  },
  {
    "id": "M106",
    "name": "M106",
    "type": "galaxy",
    "ra": 184.7417,
    "dec": 47.3039,
    "mag": 8.4,
    "sizeArcmin": 19,
    "con": "CVn"
  },
  {
    "id": "M107",
    "name": "M107",
    "type": "cluster",
    "ra": 248.1333,
    "dec": -13.0539,
    "mag": 7.9,
    "sizeArcmin": 10,
    "con": "Oph"
  },
  {
    "id": "M108",
    "name": "M108",
    "type": "galaxy",
    "ra": 167.8792,
    "dec": 55.6739,
    "mag": 10,
    "sizeArcmin": 8,
    "con": "UMa"
  },
  {
    "id": "M109",
    "name": "M109",
    "type": "galaxy",
    "ra": 179.4,
    "dec": 53.3742,
    "mag": 9.8,
    "sizeArcmin": 8,
    "con": "UMa"
  },
  {
    "id": "M110",
    "name": "M110",
    "type": "galaxy",
    "ra": 10.0917,
    "dec": 41.685,
    "mag": 8.5,
    "sizeArcmin": 17,
    "con": "And"
  },
  {
    "id": "NGC 7000",
    "name": "North America Nebula",
    "type": "nebula",
    "ra": 314.6,
    "dec": 44.5,
    "mag": 4,
    "sizeArcmin": 120,
    "con": "Cyg"
  },
  {
    "id": "NGC 869",
    "name": "Double Cluster (west)",
    "type": "cluster",
    "ra": 35.25,
    "dec": 57.1333,
    "mag": 4.3,
    "sizeArcmin": 30,
    "con": "Per"
  },
  {
    "id": "NGC 884",
    "name": "Double Cluster (east)",
    "type": "cluster",
    "ra": 35.0833,
    "dec": 57.0667,
    "mag": 4.4,
    "sizeArcmin": 30,
    "con": "Per"
  },
  {
    "id": "NGC 253",
    "name": "Sculptor Galaxy",
    "type": "galaxy",
    "ra": 11.8875,
    "dec": -25.2889,
    "mag": 7.1,
    "sizeArcmin": 27,
    "con": "Scl"
  },
  {
    "id": "NGC 7293",
    "name": "Helix Nebula",
    "type": "planetary",
    "ra": 337.4108,
    "dec": -20.8381,
    "mag": 7.3,
    "sizeArcmin": 16,
    "con": "Aqr"
  },
  {
    "id": "NGC 2070",
    "name": "Tarantula Nebula",
    "type": "nebula",
    "ra": 84.675,
    "dec": -69.1006,
    "mag": 5,
    "sizeArcmin": 40,
    "con": "Dor"
  },
  {
    "id": "NGC 3372",
    "name": "Carina Nebula",
    "type": "nebula",
    "ra": 161.2417,
    "dec": -59.8767,
    "mag": 6,
    "sizeArcmin": 120,
    "con": "Car"
  },
  {
    "id": "NGC 5139",
    "name": "Omega Centauri",
    "type": "cluster",
    "ra": 201.695,
    "dec": -47.4803,
    "mag": 3.9,
    "sizeArcmin": 36,
    "con": "Cen"
  },
  {
    "id": "NGC 104",
    "name": "47 Tucanae",
    "type": "cluster",
    "ra": 6.0236,
    "dec": -72.0814,
    "mag": 4.1,
    "sizeArcmin": 30,
    "con": "Tuc"
  },
  {
    "id": "NGC 4755",
    "name": "Jewel Box",
    "type": "cluster",
    "ra": 192.9433,
    "dec": -60.345,
    "mag": 4.2,
    "sizeArcmin": 10,
    "con": "Cru"
  },
  {
    "id": "NGC 2808",
    "name": "NGC 2808",
    "type": "cluster",
    "ra": 138.0104,
    "dec": -64.8628,
    "mag": 6.2,
    "sizeArcmin": 13,
    "con": "Car"
  },
  {
    "id": "NGC 6960",
    "name": "Veil Nebula (west)",
    "type": "nebula",
    "ra": 310.0842,
    "dec": 30.7267,
    "mag": 7,
    "sizeArcmin": 70,
    "con": "Cyg"
  },
  {
    "id": "NGC 7009",
    "name": "Saturn Nebula",
    "type": "planetary",
    "ra": 315.4417,
    "dec": -11.3614,
    "mag": 8,
    "sizeArcmin": 0.6,
    "con": "Aqr"
  },
  {
    "id": "NGC 2392",
    "name": "Eskimo Nebula",
    "type": "planetary",
    "ra": 112.2767,
    "dec": 20.9586,
    "mag": 9.1,
    "sizeArcmin": 0.8,
    "con": "Gem"
  },
  {
    "id": "IC 434",
    "name": "Horsehead Nebula region",
    "type": "nebula",
    "ra": 85.625,
    "dec": -2.45,
    "mag": 8,
    "sizeArcmin": 60,
    "con": "Ori"
  }
];
